
import { Flex } from 'components/common/flex/Flex'
import { ReactComponent as Title } from 'components/heroBanner/assets/title.svg'
import styles from 'components/heroBanner/HeroBanner.module.scss'
import { Illustration } from 'components/heroBanner/illustration/Illustration'

export const HeroBanner = () => {
  return (
    <div className={styles.container}>
      <Flex justify="between" className={styles.content}>
        <div className={styles.leftContent}>
          <Title />
          <div className={`${styles.description} text-white leading-7 font-light`}>
            Hey friends! FYI The Playground supports learning in the flow of work but check this out if you're looking
            to level up.
          </div>
        </div>
        <div className={styles.illustrationContainer}>
          <Flex className={styles.tag}>
            <span className={`${styles.tagText} italic font-medium`}>
              Overachievers Anonymous
            </span>
          </Flex>
          <Illustration />
        </div>
      </Flex>
    </div>
  )
}
